<template>
    <Modal :value="visible" :mask-closable="false">
        <div slot="close">
            <Icon type="ios-close" @click="$emit('cancel')" />
        </div>
        <div slot="header">
            <div style="line-height: 20px;">
                <div style="font-size: 20px;font-weight: 600;color: #000">导入小说</div>
                <div style="display: flex;justify-content: space-between;margin-top: 10px;flex-direction: column;">
                    <div style="color: #aaa;font-size: 14px;">请上传 zip 文件，系统会解析压缩包并导入小说数据。</div>
                    <div style="color: #aaa;font-size: 14px;">仅支持 `.zip` 格式。</div>
                </div>
            </div>
        </div>
        <Upload type="drag" :before-upload="handleUpload" action="/" accept=".zip">
            <div style="padding: 50px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>将 zip 文件拖拽到此处或点击选择文件</p>
                <p>(支持.zip)</p>
            </div>
        </Upload>
        <div v-if="file != null"
            style="display: flex;justify-content: space-between;color:#aaa;align-items: center;margin: 10px 0;font-size:15px;color:#666;border: 1px solid #aaa;padding:10px;border-radius: 12px;">
            <div>{{ file.name }}</div>
            <Icon type="md-close" :style="{ cursor: 'pointer' }" @click="file = null" />
        </div>
        <template #footer>
            <Button @click="$emit('cancel')">取消</Button>
            <Button type="primary" @click="handleSubmit" :loading="uploadLoading">确认导入</Button>
        </template>
    </Modal>
</template>

<script>
import { importNovel } from '@/api/novel'

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            file: null,
            uploadLoading: false
        }
    },
    watch: {
        visible() {
            this.file = null
        }
    },
    methods: {
        handleUpload(file) {
            this.file = file
            return false
        },
        handleSubmit() {
            if (!this.file) return
            const formData = new FormData()
            formData.append('zipFile', this.file)
            this.uploadLoading = true
            importNovel(formData).then(r => {
                this.$emit('confirm', r.data)
            }).finally(() => {
                this.uploadLoading = false
            })
        }
    }
}
</script>
